import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import styled from '@emotion/styled'
import { CSSTransition } from 'react-transition-group'
import ScreenContainer from '@screens/ScreenContainer'
import { Modal } from '@mui/material'

const BaseModal = ({ open, setClosed, animationExitDelay=300, animationClassNames='animation__modal-opacity', children, modalSlotProps={} }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const nodeRef = useRef(null)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    let timeout
    if(!open) {
      timeout = setTimeout(() => {
        setModalOpen(false)
        navigator?.virtualKeyboard?.hide()
      }, animationExitDelay)
    } else {
      setModalOpen(open)
    }
    return () => clearTimeout(timeout)
  }, [open])

  return (
    <div>
      <CSSTransition
        appear
        nodeRef={nodeRef}
        in={open}
        timeout={200}
        classNames={animationClassNames}>
        <Modal
          ref={nodeRef}
          open={open ? open : modalOpen}
          onClose={setClosed}
          slotProps={{
            root: {
              style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }
            },
            ...modalSlotProps
          }}
          className={animationClassNames}>
          {children}
        </Modal>
      </CSSTransition>
    </div>
  )
}

export default BaseModal
